const typography = {
  title: 24,
  button: 18,
  paragraph: 16,
};

export default typography;
